import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import * as AuthService from 'services/auth.service'

const CompaniaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [companias, setCompanias] = React.useState([])

  React.useEffect(() => {
    AuthService.getCompaniasHabilitadas().then(({ data }) => {
      setCompanias(data)
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='COMPAÑIA REFERENCIA' sm={4} alignRightAt='sm' />
      <Col sm={8}>
        <Field name='_idCompaniaReferencia'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-compania'
              isInvalid={iError && iTouched}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {companias.map(x => (
                <option key={x._id} value={x._id}>
                  {x.razonSocial}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CompaniaFormGroup)
